/**
 * The v2 table head (visual contract v2 §9, §2 "Capitals label"; TMMAPP-0151 §H 24), for a v2 page's
 * root: every head cell inside it in capitals — 11 / 400 at letter-spacing 0.06em, uppercase through
 * CSS (the catalog stays sentence case) — on the theme's `surface2` head row in `text2` (a label on
 * `surface2` steps up to `text2`). Scoped to the page, never the theme: tables on v1 screens keep
 * theirs until those screens are restyled.
 */
export const V2_TABLE_HEADS_SX = {
  '& .MuiTableCell-head': {
    fontSize: 11,
    lineHeight: '16px',
    fontWeight: 400,
    letterSpacing: '0.06em',
    textTransform: 'uppercase',
  },
} as const;
